export default "__VITE_ASSET__ByqXJuoJ__"